<div
	class="modal fade"
	id="eventModal"
	tabindex="-1"
	role="dialog"
	aria-labelledby="eventModalLabel"
	aria-hidden="true"
>
	<div class="modal-dialog modal-xl modal-dialog-scrollable modal-dialog-centered" role="document">
		<div class="modal-content">
			<div class="modal-header">
				<h5 class="modal-title" id="eventModalLabel">
					{{ selectedObject.name }}
					(id: {{ event.newId }})
					@if (event.vehicles.length) {
						<span>- {{ event['vehicle'] }}<br /> </span>
					}
					<app-tourism-event-transport-term-slots [slots]="slots" />
				</h5>
				<button type="button" class="btn-close" (click)="eventClose()"></button>
			</div>
			<div class="row g-3 mt-0 py-3 px-5">
				<div class="col-5 mt-0">
					<div class="form-floating">
						<input
							type="datetime-local"
							class="form-control"
							name="date_from"
							id="date_from"
							[ngModel]="event.date_from | date: 'yyyy-MM-ddTHH:mm'"
							(ngModelChange)="event.date_from = $event"
						/>
						<label class="font-15" for="date_from">Data rozpoczęcia</label>
					</div>
				</div>

				<div class="col-5 mt-0">
					<div class="form-floating">
						<input
							type="datetime-local"
							class="form-control"
							name="date_to"
							id="date_to"
							[ngModel]="event.date_to | date: 'yyyy-MM-ddTHH:mm'"
							(ngModelChange)="event.date_to = $event"
						/>
						<label class="font-15" for="date_to">Data zakończenia</label>
					</div>
				</div>

				<div class="col-2 d-grid justify-content-end align-items-center mt-0">
					<button mat-raised-button color="primary" (click)="updateEventDateTime()">Zapisz</button>
				</div>
			</div>

			@if (event.status !== undefined) {
				<div class="modal-body">
					@if (event.tasks.length !== 0) {
						<div class="row">
							<label class="col-sm-3">Zadania</label>
							<span class="col-sm-9">
								@for (task of event.tasks; track $index) {
									<div>{{ task }},</div>
								}
							</span>
						</div>
					}
					<div class="row">
						<label class="col-sm-3">Typ i status</label>
						<span class="col-sm-9">{{ event.category }} - {{ event.status }}</span>
					</div>
					<div class="row">
						<label class="col-sm-3">Opiekun</label>
						<span class="col-sm-9">
							@for (person of event.owner; track person.id) {
								<span>
									{{ person.name }}
								</span>
							}
						</span>
					</div>
					@if (event.planned_people_count) {
						<div class="row">
							<label class="col-sm-3">Liczba osób</label>
							<span class="col-sm-9">{{ event.planned_people_count }}</span>
						</div>
					}
					@if (event.tourist_guides_departure.length) {
						<div class="row">
							<label class="col-sm-3">Piloci wyjazd</label>
							<span class="col-sm-9">
								@for (person of event.tourist_guides_departure; track person.id) {
									<span>
										<a routerLink="" class="link-primary">{{ person.name }}</a
										>&nbsp;
										@if (person.phone) {
											<span>({{ person.phone }})&nbsp;</span>
										}
										@if (person.email) {
											<span>({{ person.email }})&nbsp;</span>
										}
									</span>
								}
							</span>
						</div>
					}
					@if (event.tourist_guides_program.length) {
						<div class="row">
							<label class="col-sm-3">Piloci program</label>
							<span class="col-sm-9">
								@for (person of event.tourist_guides_program; track person.id) {
									<span>
										<a routerLink="" class="link-primary">{{ person.name }}</a
										>&nbsp;
										@if (person.phone) {
											<span>({{ person.phone }})&nbsp;</span>
										}
										@if (person.email) {
											<span>({{ person.email }})&nbsp;</span>
										}
									</span>
								}
							</span>
						</div>
					}
					@if (event.tourist_guides_return.length) {
						<div class="row">
							<label class="col-sm-3">Piloci powrót</label>
							<span class="col-sm-9">
								@for (person of event.tourist_guides_return; track person.id) {
									<span>
										<a routerLink="" class="link-primary">{{ person.name }}</a
										>&nbsp;
										@if (person.phone) {
											<span>({{ person.phone }})&nbsp;</span>
										}
										@if (person.email) {
											<span>({{ person.email }})&nbsp;</span>
										}
									</span>
								}
							</span>
						</div>
					}
					<div class="row">
						<label class="col-sm-3">Kierowcy wyjazd</label>
						<span class="col-sm-9">
							@for (driver of event.drivers_departure; track driver.id) {
								<div>
									<span>
										<a routerLink="/drivers/{{ driver.id }}" class="link-primary">{{
											driver.name
										}}</a>
										&nbsp;
										@if (driver.phone) {
											<span>({{ driver.phone }})&nbsp;</span>
										}
										@if (driver.email) {
											<span>({{ driver.email }})&nbsp;</span>
										}
									</span>
								</div>
							}
						</span>
					</div>
					@if (event.drivers_program.length) {
						<div class="row">
							<label class="col-sm-3">Kierowcy program</label>
							<span class="col-sm-9">
								@for (driver of event.drivers_program; track driver.id) {
									<div>
										<span>
											@if (isOnlyDispatcher()) {
												<span> {{ driver.name }} </span>
											} @else {
												<a routerLink="/drivers/{{ driver.id }}" class="link-primary">{{
													driver.name
												}}</a>
												&nbsp;
											}
											@if (driver.phone) {
												<span>({{ driver.phone }})&nbsp;</span>
											}
											@if (driver.email) {
												<span>({{ driver.email }})&nbsp;</span>
											}
										</span>
									</div>
								}
							</span>
						</div>
					}
					@if (event.drivers_return.length) {
						<div class="row">
							<label class="col-sm-3">Kierowcy powrót</label>
							<span class="col-sm-9">
								@for (driver of event.drivers_return; track driver.id) {
									<div>
										<span>
											<a routerLink="/drivers/{{ driver.id }}" class="link-primary">{{
												driver.name
											}}</a
											>&nbsp;
											@if (driver.phone) {
												<span>({{ driver.phone }})&nbsp;</span>
											}
											@if (driver.email) {
												<span>({{ driver.email }})&nbsp;</span>
											}
										</span>
									</div>
								}
							</span>
						</div>
					}
					@if (event.program_date_from || event.program_date_to) {
						<div class="row">
							<label class="col-sm-3">Data rozpoczęcia i zakończenia programu</label>
							<span class="col-sm-9">{{ event.program_date_from }} / {{ event.program_date_to }}</span>
						</div>
					}
					@if (event.accommodation) {
						<div class="row">
							<label class="col-sm-3">Nocleg</label>
							<span class="col-sm-9">{{ event.accommodation }}</span>
						</div>
					}
					<div class="row">
						<label class="col-sm-3">Odprawa</label>
						<span class="col-sm-9"> {{ event.briefingPlace }} ({{ event.date_prepare }}) </span>
					</div>
					<div class="row">
						<label class="col-sm-3">Podstawienie</label>
						<span class="col-sm-9"> {{ event.startPlace }} ({{ event.startDate }}) </span>
					</div>
					<div class="row">
						<label class="col-sm-3">Trasa / rozkład wyjazd</label>
						<span class="col-sm-9" [innerHTML]="event.text_departure"></span>
					</div>
					<div class="row">
						<label class="col-sm-3">Program</label>
						<span class="col-sm-9" [innerHTML]="event.text_program"></span>
					</div>
					<div class="row">
						<label class="col-sm-3">Trasa / rozkład powrót</label>
						<span class="col-sm-9" [innerHTML]="event.text_return"></span>
					</div>
					<div class="row">
						<label class="col-sm-3">Kierowcy</label>
						<span class="col-sm-9" [innerHTML]="event.text_drivers"></span>
					</div>
					<div class="row">
						<label class="col-sm-3">Organizacja</label>
						<span class="col-sm-9" [innerHTML]="event.text_organization"></span>
					</div>
					<div class="row">
						<label class="col-sm-3">Klient</label>
						<span class="col-sm-9" [innerHTML]="event.text_client"></span>
					</div>
					<div class="row">
						<label class="col-sm-3">Tankowanie</label>
						<span class="col-sm-9" [innerHTML]="event.text_refueling"></span>
					</div>
					<div class="row">
						<label class="col-sm-3">Dział rozliczeń</label>
						<span class="col-sm-9" [innerHTML]="event.text_billing"></span>
					</div>
					<div class="row">
						<label class="col-sm-3">Klient - przedstawiciel na miejscu</label>
						<span class="col-sm-9" [innerHTML]="event.client_representative"></span>
					</div>
					<div class="row">
						<label class="col-sm-3">Uwagi</label>
						<span class="col-sm-9" [innerHTML]="event.text_notes"></span>
					</div>
					@if (links) {
						<div class="row">
							<label class="col-sm-3">Połączone wydarzenia</label>
							<div class="col-sm-9">
								@for (item of links; track item.event1) {
									<p>
										<a [routerLink]="'/tourism-events/' + item.event1">{{ item.event1Name }}</a>
										&nbsp;<i class="fas fa-long-arrow-alt-right"></i>&nbsp;
										<a [routerLink]="'/tourism-events/' + item.event2">{{ item.event2Name }}</a>
									</p>
								}
							</div>
						</div>
					}
				</div>
			}
			@if (!isOnlyDispatcher()) {
				<div class="modal-footer">
					<div class="container">
						<div class="row">
							<div class="col-sm">
								@if (!!event.vehicles.length) {
									<button
										class="btn"
										[ngClass]="{
											'btn-success': event.driver_informed_departure,
											'btn-outline-danger': !event.driver_informed_departure,
										}"
										(click)="driverInformed('driver_informed_departure')"
									>
										Kierowca poinformowany (wyjazd)
									</button>
								}

								@if (driverInformedDepartureHistoryLast.userName) {
									<small class="d-block mt-1">
										Ostatnia zmiana:
										{{ driverInformedDepartureHistoryLast.userName }}
										-
										{{ driverInformedDepartureHistoryLast.date }}
									</small>
								}
							</div>
							<div class="col-sm">
								@if (!!event.vehicles.length) {
									<button
										class="btn"
										[ngClass]="{
											'btn-success': event.driver_informed_return,
											'btn-outline-danger': !event.driver_informed_return,
										}"
										(click)="driverInformed('driver_informed_return')"
									>
										Kierowca poinformowany (powrót)
									</button>
								}
								@if (driverInformedReturnHistoryLast.userName) {
									<small class="d-block mt-1">
										Ostatnia zmiana:
										{{ driverInformedReturnHistoryLast.userName }}
										-
										{{ driverInformedReturnHistoryLast.date }}
									</small>
								}
							</div>
							@if (!!event.vehicles.length) {
								<div class="col-sm">
									<button
										class="btn"
										[ngClass]="{
											'btn-success': event.guide_informed,
											'btn-outline-danger': !event.guide_informed,
										}"
										(click)="guideInformed('guide_informed')"
									>
										Pilot poinformowany (wyjazd)
									</button>

									@if (guideInformedHistory.userName) {
										<small class="d-block mt-1">
											Ostatnia zmiana:
											{{ guideInformedHistory.userName }} -
											{{ guideInformedHistory.date }}
										</small>
									}
								</div>
								<div class="col-sm">
									<button
										class="btn"
										[ngClass]="{
											'btn-success': event.guide_informed_return,
											'btn-outline-danger': !event.guide_informed_return,
										}"
										(click)="guideInformed('guide_informed_return')"
									>
										Pilot poinformowany (powrót)
									</button>

									@if (guideInformedReturnHistory.userName) {
										<small class="d-block mt-1">
											Ostatnia zmiana:
											{{ guideInformedReturnHistory.userName }} -
											{{ guideInformedReturnHistory.date }}
										</small>
									}
								</div>
							}
							<div class="col-sm">
								@if (!!event.vehicles.length) {
									<button
										class="btn"
										[ngClass]="{
											'btn-success': event.client_informed,
											'btn-outline-danger': !event.client_informed,
										}"
										(click)="clientInformed()"
									>
										Klient poinformowany
									</button>
								}
								@if (clientInformedHistory.userName) {
									<small class="d-block mt-1">
										Ostatnia zmiana:
										{{ clientInformedHistory.userName }} -
										{{ clientInformedHistory.date }}
									</small>
								}
							</div>
							<div class="col-sm text-end">
								@if (event.status !== undefined) {
									<a class="btn btn-primary me-4" routerLink="/tourism-events/{{ selectedObject.id }}"
										>Więcej</a
									>
								}
								<button
									type="button"
									class="btn btn-secondary"
									(click)="eventClose()"
									data-bs-dismiss="modal"
								>
									Zamknij
								</button>
							</div>
						</div>
					</div>
				</div>
			}
		</div>
	</div>
</div>
